import { cn } from '@kognitos/lattice';

/**
 * Props for the AutomationStatusDot component.
 */
interface IAutomationStatusDotProps {
  /** Whether the automation is a draft (blue) vs. live/published (green) */
  isDraft?: boolean;
  /** Whether the automation is deactivated (renders the dot at 50% opacity) */
  isDeactivated?: boolean;
  /** Optional className overrides */
  className?: string;
}

/**
 * Colored status dot indicating automation state: green for live/published,
 * blue for draft, faded to 50% opacity when deactivated.
 */
export function AutomationStatusDot({
  isDraft = false,
  isDeactivated = false,
  className,
}: IAutomationStatusDotProps) {
  return (
    <span
      aria-hidden
      data-testid={`automation-status-dot--${isDraft ? 'draft' : 'live'}${
        isDeactivated ? '-deactivated' : ''
      }`}
      className={cn(
        'size-2 shrink-0 rounded-full',
        isDraft ? 'bg-informative' : 'bg-success',
        isDeactivated && 'opacity-50',
        className,
      )}
    />
  );
}
